import {Fill, Stroke, Style} from 'ol/style';
import GeoJSON from 'ol/format/GeoJSON';
import {hexToRGBA} from "@/assets/js/utils";
import {fire} from "@/animations/effects/fire";

/**
 * Wildfire animation — fire icons that flicker and randomly reposition inside
 * the supplied polygon area, plus a tinted polygon fill.
 *
 * Expected `data`: GeoJSON FeatureCollection with at least one Polygon feature.
 */
export function wildfire(layer, news, geoJson) {
    const features = new GeoJSON().readFeatures(geoJson, {
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857'
    });
    if (!features.length) return {getFeature: () => null};

    const parent = features[0];
    parent.setStyle(new Style({
        stroke: new Stroke({color: news.color, width: 2}),
        fill: new Fill({color: hexToRGBA(news.color, 0.18)})
    }));
    const interior = parent.getGeometry().getInteriorPoint().getCoordinates();
    parent.set('where', interior);
    layer.getSource().addFeature(parent);

    function randomPointInPolygon(polygon) {
        const extent = polygon.getExtent();
        for (let i = 0; i < 30; i++) {
            const x = extent[0] + Math.random() * (extent[2] - extent[0]);
            const y = extent[1] + Math.random() * (extent[3] - extent[1]);
            if (polygon.intersectsCoordinate([x, y])) return [x, y];
        }
        return polygon.getInteriorPoint().getCoordinates();
    }

    const polygonGeom = parent.getGeometry();

    fire(layer, {
        spawn: () => randomPointInPolygon(polygonGeom),
        count: 15,
        tick: 200,
        relocateChance: 0.1
    });

    return {
        getFeature() {
            return parent;
        }
    };
}
